export const GTM_ID = 'GTM-W75BXRJ';

export const NAVIGATION_TYPE = {
  accordion: 'accordion',
  link: 'link',
  carousel: 'carousel',
  arrow: 'arrow',
  video: 'video'
} as const;

export const PAYMENT_REQUEST_TYPES_LABELS_EVENTS = Object.freeze({
  applepay: 'Apple Pay',
  googlepay: 'Google Pay',
  paypal: 'PayPal',
  venmo: 'Venmo',
  card: undefined,
  sepa: undefined
});

export const ANALYTICS_CHECKOUT_STEP_ERROR_STEPS = Object.freeze({
  begin: Object.freeze({
    stepNumber: 1,
    stepName: 'begin_checkout'
  }),
  shipping: Object.freeze({
    stepNumber: 2,
    stepName: 'add_shipping_info'
  }),
  payment: Object.freeze({
    stepNumber: 3,
    stepName: 'add_payment_info'
  }),
  review: Object.freeze({
    stepNumber: 4,
    stepName: 'review_order'
  })
});

export const KLAVIYO_LOCATION = 'Klaviyo modal';
export const KLAVIYO_CTA_TEXT = 'Continue';
export const KLAVIYO_SAMPLING = 'Sampling';
export const KLAVIYO_FREE_SHIPPING = 'FreeShipping';

export const KLAVIYO_POPUP_TITLE = [
  { keywords: ['Sample Pack'], value: KLAVIYO_SAMPLING },
  { keywords: ['FREE Shipping'], value: KLAVIYO_FREE_SHIPPING }
];
